import type { StringMultiLocaleField, BooleanTypeMultiLocaleField } from '~/types/generated'

export default function (
  allSlugLocales: StringMultiLocaleField[],
  allPublishTranslationLocales: BooleanTypeMultiLocaleField[]
) {
  const slugs: { [key: string]: string } = {}

  allSlugLocales!.map((x: any) => (slugs[x.locale] = x.value))
  allPublishTranslationLocales?.filter((x: any) => !x.value).map((x: any) => delete slugs[x.locale])

  return slugs
}
